<template>
    <v-btn
        depressed
        :small="!medium && !xSmall"
        :x-small="xSmall"
        :color="color"
        :outlined="outlined"
        :block="block"
        :text="textOption"
        :class="color ? 'ml-2 white--text' : 'ml-2'"
        :loading="loading"
        :disabled="disabled"
        @click="press"
    >
        {{ text }}
        <v-icon :right="!!text" v-if="icon">{{ icon }}</v-icon>
    </v-btn>
</template>

<script>
export default {
    name: "WBtn",
    props: {
        loading: Boolean,
        disabled: Boolean,
        outlined: Boolean,
        block: Boolean,
        medium: Boolean,
        xSmall: Boolean,
        textOption: Boolean,
        color: String,
        text: String,
        icon: String
    },
    emits: ["press"],
    setup(props, {emit}) {
        function press() {
            emit("press");
        }
        
        return {
            press
        };
    }
};
</script>

<style scoped></style>